import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import collapseApr from '@/views/private/apr/registerApr/components/collapseapr/collapseApr.vue'
// import Tools from '@/components/tools/Tools'

export default {
  name: 'registerTable',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, collapseApr},
  data () {
    return {
      formSearch: {},
      columTemplate: ['Atividades'],
      form: {
        categoria: null,
        descricao: null
      }
    }
  },

  props: {
  },

  watch: {
  },

  mounted () {},
  methods: {
    popUptAdd () {
      this.$refs['add-novo-template'].show()
    },
    cancelarAddTemplate () {
      this.$refs['add-novo-template'].hide()
    },
    onLoad () {
      this.$refs.collapseApr.formSearch = this.formSearch
      // this.$refs.collapseApr.onLoad()
    },
    openFiles () {
      document.getElementById('impor-ex-price').click()
    },
    imporTable (e) {
      this.$emit('detalhesDespesa', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/registerApr/components/registerTable/registerTable.js